import React, { useState } from 'react';

export const PopupBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm w-full rounded-xl border border-accent-blue/30 bg-gradient-to-r from-accent-blue/90 via-accent-blue/80 to-accent-purple/80 p-3 text-white shadow-xl md:max-w-md">
      <div className="flex items-center justify-between gap-3">
        <a
          href="https://www.festicon.dk"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm font-semibold leading-5 transition-opacity hover:opacity-85 md:text-base"
        >
          Find os på Festicon den 21.-22. Oktober
        </a>
        <button
          onClick={() => setIsVisible(false)}
          aria-label="Luk banner"
          className="rounded-full bg-white/20 p-1.5 text-white transition hover:bg-white/30"
        >
          ✕
        </button>
      </div>
    </div>
  );
};
